import gql from 'graphql-tag';
import { ADDITIONAL_ACCOUNT_RELATION_FRAGMENT } from './fragments/additionalAccountViewModel.fragment';

export const GET_ADDITIONAL_ACCOUNT_LIST = gql`
  query ListOfAdditionalAccounts {
    additionalAccount {
      result: getUserRelationsList {
        error
        success
        list {
          ...AdditionalAccountRelationViewModel
        }
      }
    }
  }
  ${ADDITIONAL_ACCOUNT_RELATION_FRAGMENT}
`;
